__turbopack_context__.v({
  "carousel": "MediaCarousel-module-scss-module__nvWssa__carousel",
  "carousel__arrow": "MediaCarousel-module-scss-module__nvWssa__carousel__arrow",
  "carousel__arrow--left": "MediaCarousel-module-scss-module__nvWssa__carousel__arrow--left",
  "carousel__arrow--right": "MediaCarousel-module-scss-module__nvWssa__carousel__arrow--right",
  "carousel__dot": "MediaCarousel-module-scss-module__nvWssa__carousel__dot",
  "carousel__dot--active": "MediaCarousel-module-scss-module__nvWssa__carousel__dot--active",
  "carousel__indicators": "MediaCarousel-module-scss-module__nvWssa__carousel__indicators",
  "carousel__slide": "MediaCarousel-module-scss-module__nvWssa__carousel__slide",
  "carousel__slide--active": "MediaCarousel-module-scss-module__nvWssa__carousel__slide--active",
});
